module.exports = __webpack_public_path__ + "static/knh-8729931f630e64208be081f847d07f0f.jpg";